import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/system";
import { Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
import _ from "@lodash";
import { isValSelected } from "app/main/apps/common/AuraFunctions";

function ContainerFormContent({ fields = [], replace, startBoxNumber, control, showSelectionBox,isAddTocontainer }) {
  const {
    formState: { errors },
    getValues,
  } = useFormContext();
  const formData = getValues();

  const getHeader = () => {
    return (
      <>
        {showSelectionBox && <TableCell sx={{ width: 60, padding: 0 }} />}
        <TableCell>LEN</TableCell>
        <TableCell>THK</TableCell>
        <TableCell>HGT</TableCell>
        <TableCell>Color</TableCell>
        <TableCell>Shape</TableCell>
        <TableCell>Polish</TableCell>
        <TableCell>Sub Type</TableCell>
        <TableCell sx={{ maxWidth: "80px" }}>Quantity</TableCell>
        <TableCell>Weight</TableCell>
        {!showSelectionBox && <TableCell>Price</TableCell>}
        <TableCell>Total Weight</TableCell>
        {!showSelectionBox && <TableCell>Amount</TableCell>}
        <TableCell>Reference No</TableCell>
        <TableCell>Decedents</TableCell>
        <TableCell>Box No *</TableCell>
      </>
    );
  };

  function onSelectionchange(index, orderDetail) {
    let start;
    if (fields) {
      const data = formData?.order_detail.map((detail, detailIndex) => {
        if (detailIndex >= index) {
          const updateObject = {};
          if (index === detailIndex) {
            // Selected order details.
            // update is selected field
            // Remove box number if is_selected = 0
            // add box number if is_selected = 1
            if (detail.is_selected === 1 && detail?.original_qty > 0) {
              if (!start) {
                start = parseInt(detail.box_number_from || startBoxNumber, 10);
              }
              updateObject.box_number_from = start;
              const quantity = detail?.box_quantity || detail?.quantity;
              const boxTo = start - 1 + parseInt(quantity, 10);
              updateObject.box_quantity = quantity;
              detail.box_number_to = boxTo;
              start = boxTo + 1;
              return { ...detail, ...updateObject };
            }
            // This portion is used when order is assigned to containers from confirmed page
            if(isAddTocontainer && startBoxNumber > 0){
              if (!start) {
                start = parseInt(detail.box_number_from || startBoxNumber, 10);
              }
              updateObject.box_number_from = start;
              const quantity = detail?.box_quantity || detail?.quantity;
              const boxTo = start - 1 + parseInt(quantity, 10);
              updateObject.box_quantity = quantity;
              detail.box_number_to = boxTo;
              start = boxTo + 1;
              return { ...detail, ...updateObject };
            }
            if (!start) {
              start = parseInt(startBoxNumber, 10);
            }
            updateObject.box_number_from = null;
            updateObject.box_quantity = null;
            detail.box_number_to = null;
            return { ...detail, ...updateObject };
          }
          if (detail.is_selected && detail?.original_qty > 0) {
            if (!start) {
              start = parseInt(detail.box_number_from || 1, 10);
            }
            // Other orders. Update box number only
            updateObject.box_number_from = start;
            const quantity = detail?.box_quantity || detail?.quantity;
            const boxTo = start - 1 + parseInt(quantity, 10);
            updateObject.box_quantity = quantity;
            detail.box_number_to = boxTo;
            start = boxTo + 1;
            return { ...detail, ...updateObject };
          }
          return detail;
        }
        if (detail.is_selected && detail?.original_qty > 0) {
          start = parseInt(detail.box_number_to, 10) + 1;
        }
        return detail;
      });
      replace(data);
    }
  }

  function onEdittableDataChange(index, type) {
    let start;
    if (fields) {
      const data = formData?.order_detail.map((detail, detailIndex) => {
        const updateObject = {};
        if (detailIndex >= index) {
          // Update only upcoming order_detail records
          if (index === detailIndex) {
            // Current editted order detail
            if (detail.is_selected === 1 && detail?.original_qty > 0) {
              // Take current editted box number
              start = parseInt(detail.box_number_from, 10);
              const quantity = detail?.quantity;
              const boxTo = start - 1 + parseInt(quantity, 10);
              if (type === "quantity") {
                // Update box quantity
                // Update box box_number_to
                // Update start
                updateObject.box_quantity = detail?.quantity;
                detail.box_number_to = boxTo;
                start = boxTo + 1;
              }
              if (type === "box_number_from") {
                // Update box box_number_to
                // Update start
                detail.box_number_to = boxTo;
                start = boxTo + 1;
              }
              if (type === "box_number_to") {
                // update box quantity
                // Update start
                const to = parseInt(detail?.box_number_to, 10);
                const from = parseInt(detail?.box_number_from, 10);
                const diff = (to - from) + 1;
                if (from <= to && quantity && diff <= quantity) {
                  // Checked Condition to not update negative value
                  // Difference between box should not exceeds the quantity
                  const boxQuantity =
                    parseInt(detail?.box_number_to, 10) -
                    parseInt(detail?.box_number_from, 10);
                  updateObject.box_quantity = boxQuantity + 1;
                }
                start = to + 1;
              }
              return { ...detail, ...updateObject };
            }
            updateObject.box_number_from = null;
            updateObject.box_quantity = null;
            detail.box_number_to = null;
            return { ...detail, ...updateObject };
          }
          if (detail.is_selected && detail?.original_qty > 0) {
            const detailObject = {};
            if (!start) {
              start = parseInt(detail.box_number_from, 10);
            }
            // Other orders. Update box number only
            detailObject.box_number_from = start;
            const quantity = detail?.box_quantity || detail?.quantity;
            const boxTo = start - 1 + parseInt(quantity, 10);
            // detailObject.box_quantity = quantity;
            detail.box_number_to = boxTo;
            start = boxTo + 1;
            return { ...detail, ...detailObject };
          }
          return detail;
        }
        if (detail.is_selected && detail?.original_qty > 0) {
          start = parseInt(detail.box_number_to, 10) + 1;
        }
        return detail;
      });
      replace(data);
    }
  }

  return (
    <>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 0 }}
          colSpan={15}
        >
          <Box>
            {fields && fields.length > 0 && (
              <Table
                className="simple"
                sx={{
                  "&.simple tbody tr td": {
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  },
                }}
              >
                <TableHead>
                  <TableRow>{getHeader()}</TableRow>
                </TableHead>
                <TableBody>
                  {fields.map((data, index) => {
                    const product = data;
                    return (
                      <Fragment key={data.id || index}>
                        <TableRow key={product.id}>
                          {showSelectionBox && (
                            <TableCell padding="checkbox">
                              <Controller
                                control={control}
                                name={`order_detail[${index}].is_selected`}
                                defaultValue={false}
                                render={({ field: { onChange, value } }) => (
                                  <Checkbox
                                    checked={value === "1" || value === 1}
                                    onChange={(e) => {
                                      if (e.target.checked === true)
                                        onChange(1);
                                      else onChange(0);
                                      onSelectionchange(index);
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                          )}
                          <TableCell>{product.length}</TableCell>
                          <TableCell>{product.width}</TableCell>
                          <TableCell>{product.height}</TableCell>
                          <TableCell sx={{ width: "190px", maxWidth: "190px" }}>
                            {product.color}
                          </TableCell>
                          <TableCell sx={{ width: "190px", maxWidth: "190px" }}>
                            {product.type}
                          </TableCell>
                          <TableCell sx={{ width: "190px", maxWidth: "190px" }}>
                            {product.polish}
                          </TableCell>
                          <TableCell sx={{ width: "190px", maxWidth: "190px" }}>
                            {product.sub_type}
                          </TableCell>
                          <TableCell sx={{ width: "80px", maxWidth: "80px" }}>
                            <Controller
                              control={control}
                              name={`order_detail[${index}].quantity`}
                              rules={{
                                required: {
                                  value: true,
                                  message: "Required",
                                },
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  onChange={(ev) => {
                                    product.quantityChanged = false;
                                    if (
                                      ev.target.value !== "e" &&
                                      !_.isNaN(Number(ev.target.value))
                                    ) {
                                      field.onChange(Number(ev.target.value));
                                      product.quantityChanged = true;
                                    }
                                  }}
                                  onBlur={(ev) => {
                                    // Seperated onChange and onBlur to improve screen performance
                                    if (product?.quantityChanged)
                                      onEdittableDataChange(index, "quantity");
                                    product.quantityChanged = false;
                                  }}
                                  className="mb-24"
                                  id={`order_detail[${index}].quantity`}
                                  variant="standard"
                                  fullWidth
                                  size="small"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  disabled={!product.is_selected}
                                  error={
                                    !!(
                                      errors &&
                                      errors?.order_detail &&
                                      errors?.order_detail[index]?.quantity
                                    )
                                  }
                                  helperText={
                                    errors &&
                                    errors?.order_detail &&
                                    errors?.order_detail[index]?.quantity
                                      ?.message
                                  }
                                  required
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell sx={{ width: "100px", maxWidth: "100px" }}>
                            {product.weight} lbs
                          </TableCell>
                          {!showSelectionBox && (
                            <TableCell>${product.unit_price}</TableCell>
                          )}
                          <TableCell>
                            {Number(product.quantity) * Number(product.weight)}{" "}
                            lbs
                          </TableCell>
                          {!showSelectionBox && (
                            <TableCell>
                              $
                              {Number(product.quantity) *
                                Number(product.unit_price)}
                            </TableCell>
                          )}
                          <TableCell
                            sx={{
                              width: "90px",
                              maxWidth: "90px",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {product?.customer_provider_number}
                          </TableCell>
                          <TableCell
                            sx={{
                              width: "90px",
                              maxWidth: "90px",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {product?.decedent}
                          </TableCell>
                          <TableCell sx={{ width: "200px", maxWidth: "200px" }}>
                            <div className="flex items-center gap-10">
                              <Controller
                                control={control}
                                name={`order_detail[${index}].box_number_from`}
                                rules={{
                                  required: {
                                    value: true,
                                    message: "Required",
                                  },
                                }}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    onChange={(ev) => {
                                      product.boxFromNumberChanged = false;
                                      if (
                                        ev.target.value !== "e" &&
                                        !_.isNaN(Number(ev.target.value))
                                      ) {
                                        field.onChange(Number(ev.target.value));
                                        product.boxFromNumberChanged = true;
                                      }
                                    }}
                                    onBlur={(ev) => {
                                      // Seperated onChange and onBlur to improve screen performance
                                      if (product?.boxFromNumberChanged)
                                        onEdittableDataChange(
                                          index,
                                          "box_number_from"
                                        );
                                      product.boxFromNumberChanged = false;
                                    }}
                                    className="mb-24"
                                    id={`order_detail[${index}].box_number_from`}
                                    variant="standard"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    disabled={!product.is_selected || product?.original_qty === 0}
                                    error={
                                      !!(
                                        errors &&
                                        errors?.order_detail &&
                                        errors?.order_detail[index]
                                          ?.box_number_from
                                      )
                                    }
                                    helperText={
                                      errors &&
                                      errors?.order_detail &&
                                      errors?.order_detail[index]
                                        ?.box_number_from?.message
                                    }
                                    required={isValSelected(
                                      product.is_selected
                                    )}
                                  />
                                )}
                              />
                              to
                              <Controller
                                control={control}
                                name={`order_detail[${index}].box_number_to`}
                                rules={{
                                  required: {
                                    value: true,
                                    message: "Required",
                                  },
                                }}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    onChange={(ev) => {
                                      product.boxToNumberChanged = true;
                                      if (
                                        ev.target.value !== "e" &&
                                        !_.isNaN(Number(ev.target.value))
                                      ) {
                                        field.onChange(Number(ev.target.value));
                                        product.boxToNumberChanged = true;
                                      }
                                    }}
                                    onBlur={(ev) => {
                                      // Seperated onChange and onBlur to improve screen performance
                                      if (product?.boxToNumberChanged)
                                        onEdittableDataChange(
                                          index,
                                          "box_number_to"
                                        );
                                      product.boxToNumberChanged = false;
                                    }}
                                    className="mb-24"
                                    id={`order_detail[${index}].box_number_to`}
                                    variant="standard"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    disabled={!product.is_selected || product?.original_qty === 0}
                                    error={
                                      !!(
                                        errors &&
                                        errors?.order_detail &&
                                        errors?.order_detail[index]
                                          ?.box_number_to
                                      )
                                    }
                                    helperText={
                                      errors &&
                                      errors?.order_detail &&
                                      errors?.order_detail[index]?.box_number_to
                                        ?.message
                                    }
                                    required={isValSelected(
                                      product.is_selected
                                    )}
                                  />
                                )}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      </Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
}

export default ContainerFormContent;
